import { i as s, _ as b } from "./isObjectLike.YJTOHc8M.js";
var e = b, i = s, t = "[object Symbol]";
function a(o) {
  return typeof o == "symbol" || i(o) && e(o) == t;
}
var m = a;
export {
  m as i
};
//# sourceMappingURL=isSymbol.CZPCZPYP.js.map
